import { ApplicationService } from '../../core/application.service';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/api.service';
import 'rxjs/add/operator/finally';

export class TranslateStaticLoader {
  private observable$: Observable<any>;

  constructor(private http: ApiService, private application: ApplicationService) {
  }

  public getTranslation(lang: string) {
    if (!this.observable$) {
      let appConfig = this.application.getConfig();
      let templateName = appConfig.template;
      this.observable$ = this.http
        .get(`/template/b2c/${templateName}/translations/${lang}.json`)
        .finally(() => this.observable$ = null);
    }
    return this.observable$
  }
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/multi-language/browser/translate-static-loader.service.ts